var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com__box"},[_c('h4',{staticClass:"explain mb-5"},[_vm._t("default")],2),_c('div',{staticClass:"loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }